import { z } from "zod";
import {
  ADDRESS,
  ADDRESS_1,
  ADDRESS_2,
  ALTERNATE_LOGIN_ID,
  CITY,
  COMMUNITY,
  COMMUNITY_NAME,
  COUNTRY,
  DOB,
  EMAIL_ID,
  END_DATE,
  FIRST_NAME,
  LAST_NAME,
  MOBILE_NO,
  ORGANIZATION,
  PO_BOX,
  ROLE,
  START_DATE,
  STATE,
  USERNAME,
  ZIPCODE,
} from "./consts";

export const schema = z.object({
  [USERNAME]: z.string().min(2, "This field is required"),
  [ALTERNATE_LOGIN_ID]: z
    .string()
    .min(4, "Please enter Alternate Login ID (Min Length is 4)"),
  [FIRST_NAME]: z.string().min(2, "This field is required"),
  [LAST_NAME]: z.string().min(2, "This field is required"),
  [MOBILE_NO]: z.string().min(10, "This field is required"),
  [EMAIL_ID]: z
    .string()
    .min(1, "This field is required")
    .email("This is not a valid email."),
  [ADDRESS]: z.object({
    [ADDRESS_1]: z.string().min(1, "This field is required"),
    [ADDRESS_2]: z.string().optional(),
    [STATE]: z.string().min(1, "This field is required"),
    [CITY]: z.string().min(1, "This field is required"),
    [ZIPCODE]: z
      .string()
      .min(1, "This field is required")
      .regex(/^[0-9]{5}-[0-9]{4}$/, "Enter ZIP code in XXXXX-XXXX format."),
    [PO_BOX]: z.string().optional(),
    [COUNTRY]: z.string().min(1, "This field is required"),
  }),
  [ORGANIZATION]: z.string().min(1, "This field is required"),
  [DOB]: z.string().optional(),
  [COMMUNITY]: z
    .object({
      [COMMUNITY_NAME]: z.string().min(1, "This field is required"),
      [ROLE]: z.string().min(1, "This field is required"),
      [START_DATE]: z
        .union([z.string(), z.date()])
        .refine((val) => !isNaN(Date.parse(val.toString())), {
          message: "Invalid date format.",
        }),
      [END_DATE]: z
        .union([z.string(), z.date()])
        .refine((val) => !val || !isNaN(Date.parse(val.toString())), {
          message: "Invalid date format.",
        })
        .optional(),
    })
    .array(),
});

export const affiliationSchema = schema.pick({ [COMMUNITY]: true });

export type formValues = z.infer<typeof schema>;
